import { operationsList, producerOperationsList } from 'src/features/application/operationsList';
import { Selection } from '@typeRoots/common/checkListModal';

const allOperations = { ...operationsList, ...producerOperationsList };

// Converting selection from backend to modal format.
export const convertSelection = (operations: string[]): Selection[] => {
  return operations.flatMap((operationName) => {
    // Iterate over each key in the operationsList
    return Object.keys(allOperations).flatMap((key) => {
      // Ensure 'key' is of a valid type within the operationsList keys
      const operationsForKey = allOperations[key as keyof typeof allOperations];

      // Find the operation that matches the operationName
      const operation = operationsForKey.find((op) => op.name === operationName);

      // If a match is found, return the corresponding object with type and subtype
      if (operation) {
        return { type: key, subtype: { name: operation.name, value: operation.value } };
      }

      // Return an empty array if no match is found
      return [] as Selection[];
    });
  });
};
